import React from "react";
import { createRoot } from "react-dom/client";
import AppRoot from "./App.jsx";

// Prism theme + languages (global, loaded once)
import "prismjs/themes/prism-tomorrow.css";
import Prism from "prismjs";

import "prismjs/components/prism-javascript";
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-typescript";
import "prismjs/components/prism-tsx";
import "prismjs/components/prism-json";
import "prismjs/components/prism-java"; // good for Apex too
import "prismjs/components/prism-bash";
import "prismjs/components/prism-sql";

const root = createRoot(document.getElementById("root"));
root.render(<AppRoot />);
